module.exports = __webpack_public_path__ + "static/img/众绘logo-011.1c61662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/众绘logo-011.jpg
// module id = UZEO
// module chunks = 3